<template>
  <el-dialog
    v-if="isShow"
    title="Add Blocked Autobook"
    :visible.sync="isShow"
  >
    <el-form
      ref="noAutobookForm"
      v-loading="isSaving"
      :rules="rules"
      :model="noautobook"
    >
      <el-row>
        <el-col :md="24">
          <el-form-item
            label="Carrier Service"
            prop="carrier_service"
          >
            <el-select
              v-model="noautobook.carrier_service"
              value-key="id"
              placeholder="Select a carrier service"
              class="w-100"
              clearable
            >
              <el-option
                v-for="service in services"
                :key="service.id"
                :label="`${service.carrier.name}, ${service.name}, ${service.chainit}`"
                :value="service"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isShow = false">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="create"
      >
        Create
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true
    },
    teamId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      noautobook: {},
      services: [],
      isShow: false,
      isSaving: false,
      rules: {
        carrier_service: [
          { required: true, message: 'Please select a carrier service', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.loadCarrierServices()
  },
  methods: {
    loadCarrierServices () {
      this.$sdk.service.list(builder => {
        builder.page = 1
        builder.limit = 100
        builder.include = ['carrier']
        builder.filters = { account_carrier_service_setting_strict_account: [this.accountId] }
        builder.order = 'uuid:asc'
      }).then(res => {
        this.services = res
      })
    },
    create () {
      this.$refs.noAutobookForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          let team = new this.$sdk.team()
          team.id = this.teamId
          this.noautobook.team = team
          this.$sdk.noautobook.create(this.noautobook, builder => {
            builder.context = { resource: 'pivot' }
            builder.include = ['team', 'carrier_service']
          })
            .then(() => this.$message({ message: 'Successfully created', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.isShow = false
              this.$emit('saved')
            })
        }
      })
    }
  }
}
</script>
